import apiClient from "../api/apiClient"
import { endPoints } from "../config/endpoints";

export const packageService = {
    async getTripPackages(tripId)
    {
         const response=await apiClient.get(`${endPoints.package.getTripPackages}/${tripId}`);
         return response.data
       
    }
}